export const DISPUTE_CHOICES: { id: number; name: string }[] = [
  { id: 1, name: 'Yes' },
  { id: 0, name: 'No' },
];

export const FORM_DEFAULT_VALUES: { adverse: { dispute: number | null; comments: string | null } } = {
  adverse: {
    dispute: null,
    comments: null,
  },
};
